// Ids that land in a URL path go through here. A commission carrier campaign is `commission#2026-08`;
// left raw, the `#` starts a fragment and the request reaches `/campaigns/commission` instead.
export function pathSegment(value: string): string {
  return encodeURIComponent(value);
}
